import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddUnitsSlice = createSlice({
    name: "addUnitsRequest",
    initialState,
    reducers: {
        addUnitsRequest(state) {
            state.loading = true;
        },
        addUnitsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addUnitsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        addUnitsStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    addUnitsRequest,
    addUnitsRequestSuccess,
    addUnitsRequestError,
    addUnitsStateReset,
} = AddUnitsSlice.actions;

export default AddUnitsSlice.reducer;
